module.exports = __webpack_public_path__ + "static/media/video.f3d9674e.svg";